module.exports = __webpack_public_path__ + "giving/public/shared/assets/union_pay.svg?664066f391b0946bfc24bc8c240cba66";